import React from 'react';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import {Modal, message, Popover, Descriptions, Button} from 'antd';
import HttpTool from "../../../tool/HttpTool";
import styles from "./index.less";
import ModalBase from "../../../components/modalBase";
import ModalDelete from "../../../components/modalDelete/ModalDelete";

//购买者名称，购买数量，购买商品名称

const MB = new ModalBase()
const MD = new ModalDelete()
const BuyTypeMap = {
  'position': '购买职业',
  'cap': '购买技能',
  // 'device': '购买容器',
}

export default class BuyMsgList extends ListPage {
  constructor(props) {
    super(props);
  }

  base_getListConfig() {
    return {
      table: {
        columns: this.getTableColumns(),
        url: APILXD.getConfBuyStatsList,
        otherParam: null,
        couldSelect: true,
        option: {
          rowKey: '_id',
        }
      },
      new: {
        defaultValue: '新增购买轮播',
        action: () => {
          this.add();
        }
      },
      search: {
        seniorSearch: this.getSeniorSearch(),
        option: {
          openSenior: true,
          hideInput: true,
          placeholder: '请输入商品名称搜索',
          reg: /^[\s\S]*$/,
          beforeSubmit: (value) => {
            value.commodityId = value.capSel || value.positionSel

            return true;
          },
        }
      },
      extraBox: ()=>{
        return <div style={{float:"left"}}>
          <Button
            type={"primary"}
            danger={true}
            style={{marginLeft: "20px"}}
            disabled={!(this.state.selectedRowKeys && this.state.selectedRowKeys.length)}
            onClick={()=>{
              console.log(this.state.selectedRowKeys)
              MD.show({
                  title: "提示",
                  okTitle: "确定",
                  closeTitle: "取消",
                },
                {}
                ,
                {
                  otherParam: {_ids: this.state.selectedRowKeys},
                  content: `勾选的${this.state.selectedRowKeys.length}个轮播`,
                  url: APILXD.delConfBuyStats,
                  apiType: 'post',
                  callBack: (state) => {
                    //删除成功回调
                    if(state === "success"){
                      if(this.items?.length === 1 && this.state.page > 1){
                        //当前页的最后一条
                        this.setState({
                          page: this.state.page - 1
                        },()=>{
                          this._loadDataForNet();
                        })
                      }else{
                        this._loadDataForNet();
                      }
                      this.setState({
                        selectedRowKeys: [],
                      })
                    }
                  }
                });
            }}
          >
            批量删除
          </Button>
        </div>
      }
    }
  }

  getSeniorSearch() {
    return {
      colCount: 3,
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 18, offset: 0},
      },
      parameterArr: [
        {
          field: "status",
          name: "状态",
          type: 'select',
          selectType: 'value',
          reg: (v) => {
            return true;
          },
          option: {
            allowClear: true,
          },
          data: [
            {
              title: '已上线',
              value: 'online',
            },
            {
              title: '已下线',
              value: 'offline',
            },
          ]
        },
        {
          field: "commodityType",
          name: "购买类型",
          type: 'Select',
          selectType: 'value',
          reg: (v)=>{
            return !!v
          },
          option: {
            allowClear: true,
          },
          data: Object.keys(BuyTypeMap).map((key)=>{
            return {
              title: BuyTypeMap[key],
              value: key
            }
          }),
          onChange: (value, state, changeState)=>{
            console.log(value);
            let newArr = state.parameterArr;
            newArr.forEach((obj) => {
              if (obj.mark === 'positionSel') {
                obj.field = ['position'].includes(value) ? obj.mark : null;
              }
              if (obj.mark === 'capSel') {
                obj.field = ['cap'].includes(value) ? obj.mark : null;
              }
            });
            changeState('parameterArr', newArr);
          }
        },
        {
          mark: "positionSel",
          field: null,
          name: "商品",
          type: 'Select',
          selectType: 'value',
          verMessage: "请选择要评论的商品",
          reg: (v)=>{
            return !!v
          },
          option: {
            showSearch: true,
            onSearch: () => { },
            filterOption: (input, option) => {
              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            optionFilterProp: "children",
          },
          apiConfig: {
            url: APILXD.getPersonagePositionSimplifiedList,
            fillObject: (json) => {
              let data = [];
              for (let obj of json) {
                data.push({
                  title: obj.name,
                  value: obj._id,
                });
              }
              return data;
            }
          }
        },
        {
          mark: "capSel",
          name: "商品",
          type: 'Select',
          selectType: 'value',
          verMessage: "请选择要评论的商品",
          reg: (v)=>{
            return !!v
          },
          option: {
            showSearch: true,
            onSearch: () => { },
            filterOption: (input, option) => {
              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            optionFilterProp: "children",
          },
          apiConfig: {
            url: APILXD.getPersonageCapSimplifiedList,
            fillObject: (json) => {
              let data = [];
              for (let obj of json) {
                data.push({
                  title: obj.commodityName,
                  value: obj._id,
                });
              }
              return data;
            }
          }
        },
      ],
    }
  }

  getAddData(defaultData) {
    let defaultOption = {
      type: "input",
      ver: true,
      reg: /^[\S\s]{0,50}$/,
      verMessage: "请填写，最多50个字符",
      required: true,
    };
    let props = {
      colCount: 1,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 16, offset: 0 },
      },
      parameterArr: [
        {
          ...defaultOption,
          field: "commodityType",
          name: "购买类型",
          type: 'Select',
          selectType: 'value',
          reg: (v)=>{
            return !!v
          },
          verMessage: "请选择购买类型",
          option: {
            disabled: !!defaultData,
            defaultValue: defaultData?.commodityType?{
              key: defaultData.commodityType,
              value: defaultData.commodityType,
            }:null
          },
          data: Object.keys(BuyTypeMap).map((key)=>{
            return {
              title: BuyTypeMap[key],
              value: key
            }
          }),
          onChange: (value, state, changeState)=>{
            console.log(value);
            let newArr = state.parameterArr;
            newArr.forEach((obj) => {
              if (obj.mark === 'positionSel') {
                obj.field = ['position'].includes(value) ? obj.mark : null;
              }
              if (obj.mark === 'capSel') {
                obj.field = ['cap'].includes(value) ? obj.mark : null;
              }
            });
            changeState('parameterArr', newArr);
          }
        },
        {
          ...defaultOption,
          field: "userName",
          name: "购买者名称",
          type: 'input',
          reg: /^[\S\s]{1,20}$/,
          verMessage: "请填写购买者名称，最多20个字符",
          option: {
            maxLength: "20",
            defaultValue: defaultData?.userName
          }
        },
        {
          ...defaultOption,
          mark: "positionSel",
          field: (defaultData && ['position'].includes(defaultData.commodityType)) ?'positionSel':null,
          name: "商品",
          type: 'Select',
          selectType: 'value',
          verMessage: "请选择要评论的商品",
          reg: (v)=>{
            return !!v
          },
          option: {
            disabled: !!defaultData,
            showSearch: true,
            onSearch: () => { },
            filterOption: (input, option) => {
              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            optionFilterProp: "children",
            defaultValue: defaultData?.commodityId? {
              key: defaultData.commodityId,
              value: defaultData.commodityId
            }: undefined
          },
          apiConfig: {
            url: APILXD.getPersonagePositionSimplifiedList,
            fillObject: (json) => {
              let data = [];
              for (let obj of json) {
                data.push({
                  title: obj.name,
                  value: obj._id,
                });
              }
              return data;
            }
          }
        },
        {
          ...defaultOption,
          mark: "capSel",
          field: (defaultData && ['cap'].includes(defaultData.commodityType)) ?'capSel':null,
          name: "商品",
          type: 'Select',
          selectType: 'value',
          verMessage: "请选择要评论的商品",
          reg: (v)=>{
            return !!v
          },
          option: {
            disabled: !!defaultData,
            showSearch: true,
            onSearch: () => { },
            filterOption: (input, option) => {
              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            optionFilterProp: "children",
            defaultValue: defaultData?.commodityId? {
              key: defaultData.commodityId,
              value: defaultData.commodityId
            }: undefined
          },
          apiConfig: {
            url: APILXD.getPersonageCapSimplifiedList,
            fillObject: (json) => {
              let data = [];
              for (let obj of json) {
                data.push({
                  title: obj.commodityName,
                  value: obj._id,
                });
              }
              return data;
            }
          }
        },
        {
          ...defaultOption,
          field: "buyCount",
          name: "购买数量",
          type: 'inputNumber',
          reg: (v)=>{
            return v>0
          },
          verMessage: "请填写购买数量，0-10000",
          option: {
            style: {width: '100%'},
            max: 10000,
            defaultValue: defaultData?.buyCount
          }
        },
      ],
    };
    return {
      props,
      otherParam: null
    }
  }

  add(defaultValue) {
    let addData = this.getAddData(defaultValue);
    MB.show(
      {
        title: defaultValue?"编辑购买轮播":"新增购买轮播",
        okTitle: "确定",
        closeTitle: "取消",
      },
      addData.props
      ,
      {
        otherParam: defaultValue?{
          _id: defaultValue._id
        }:{},
        url: defaultValue?APILXD.updateConfBuyStats:APILXD.addConfBuyStats,
        beforeSubmit: (param) => {
          param.commodityId = param.capSel || param.positionSel
          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state == 'success' && this._loadDataForNet();
        }
      });
  }

  /**
   *  列表数据配置
   */
  getTableColumns() {
    return [
      {
        title: '购买类型',
        dataIndex: 'commodityType',
        key: 'commodityType',
        render: (v) => {
          return BuyTypeMap[v]
        }
      },
      {
        title: '购买者名称',
        dataIndex: 'userName',
        key: 'userName',
        width: 120,
      },
      {
        title: '商品名称',
        dataIndex: 'commodityName',
        key: 'commodityName',
      },
      {
        title: '购买数量',
        dataIndex: 'buyCount',
        key: 'buyCount',
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        render: (text) => {
          return text === 'online' ? <span style={{color: 'dodgerblue'}}>已上线</span> :
            <span style={{color: 'darkorange'}}>已下线</span>
        }
      },
      {
        title: '操作',
        width: 220,
        render: (text, record, index) => {
          return (
            <div>
              {
                this.powerConfig.Edit
                  ? (record.status === 'online' ? <span onClick={() => {
                      this.changeState(record._id, 'offline')
                    }} style={{color: "darkorange"}} className={styles.btnCopy}>{"下线轮播"}</span> :
                    <span onClick={() => {
                      this.changeState(record._id, 'online')
                    }} style={{color: "dodgerblue"}} className={styles.btnEdit}>{"上线轮播"}</span>)
                  : null
              }
              {
                this.powerConfig.Edit
                  ?  <span onClick={() => {
                    this.add(record)
                  }} className={styles.btnEdit}>{"修改"}</span>
                  : null
              }
              {
                this.powerConfig.Delete && record.status === 'offline'
                  ?  <span onClick={() => {
                    MD.show({
                        title: "提示",
                        okTitle: "确定",
                        closeTitle: "取消",
                      },
                      {}
                      ,
                      {
                        otherParam: {_ids: [record._id]},
                        content: record.name,
                        url: APILXD.delConfBuyStats,
                        apiType: 'post',
                        callBack: (state) => {
                          //删除成功回调
                          if(state === "success"){
                            if(this.items?.length === 1 && this.state.page > 1){
                              //当前页的最后一条
                              this.setState({
                                page: this.state.page - 1
                              },()=>{
                                this._loadDataForNet();
                              })
                            }else{
                              this._loadDataForNet();
                            }
                          }
                        }
                      });
                  }} className={styles.btnDelete}>{"删除"}</span>
                  : null
              }
            </div>
          )
        }
      },
    ]
  }

  changeState(id, status) {
    Modal.confirm({
      title: '提示',
      content: "确定" + (status === 'online' ? "上线" : "下线") + "该轮播信息吗？",
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        let param = {
          _id: id,
          status,
        };
        let successCB = (code, msg, json, option) => {
          this.setState({loading: false}, () => {
            message.success('操作成功');
            this._loadDataForNet();
          });
        };
        let failureCB = (code, msg) => {
          this.setState({loading: false}, () => {
            message.error(msg);
          });
        };

        this.setState({loading: true});

        HttpTool.post(APILXD.updateConfBuyStatsStatus, successCB, failureCB, param);
      }
    })
  }
}